import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button , Dropdown , DropdownToggle, 
  DropdownMenu, DropdownItem
} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';
import IconBook from 'react-icons/lib/fa/book'
import IconForms from 'react-icons/lib/fa/wpforms'

import * as actions from '../../actions/proveedores';
import Modal from "./Modal";
import KardexProveedor from './ModalKardexProveedor';

import _ from "lodash";
import {API_URL,api} from '../../actions/_request';

import swal from 'sweetalert2';

import Menu from '../facturacion/menu.js';

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var label="";
        var contacto="";
        var telefono="";
        var value="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "label":
              label=filtered[i].value;
              break;
            case "contacto":
              contacto=filtered[i].value;
              break;
            case "telefono":
              telefono=filtered[i].value;
              break;
              case "value":
              value=filtered[i].value;
              break;            
          }
        }
        api().get(`/proveedores/conteo?id=${value}&label=${label}&contacto=${contacto}&telefono=${telefono}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/proveedores/busqueda?id=${value}&label=${label}&contacto=${contacto}&telefono=${telefono}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class Prveedores extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            kardexModal : false,
            prospectoid : null,
            title       : "",
            opcionConsulta : 0,
             data: [],
             pages: null,
             loading: true,
            seleccion_id : '',
            altas:false,
            bajas:false,
            cambios:false,
            reportes:false,

        };
        this.toggle 			= this.toggle.bind(this);
        this.toggleKardex = this.toggleKardex.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleChangecheckbox       = this.handleChangecheckbox.bind(this);
        this.toggle_drop       = this.toggle_drop.bind(this);
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }
   toggle(evt, prospectoid = null, title = "Agregar Proveedor")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
        });
    }

    toggleKardex(evt, opcion, title = "Cargos / Abonos")
    {
      let {seleccion_id} = this.state;

      if(seleccion_id !== '' && opcion!=0 && opcion!=4){

        let {kardexModal} = this.state;
        let {opcionConsulta} = this.state;

        opcionConsulta = opcion;

        this.setState({
            kardexModal       : !kardexModal,
            title       : title,
            opcionConsulta : opcionConsulta
        });
      }else{
        if(opcion==0) {
            window.open(`${API_URL}/proveedores/cuentas_pagar`);
        }else{
           if(opcion==4) {
              window.open(`${API_URL}/proveedores/cuentas_pagar_desglosado`);
            }else{
              swal("Oops..", "Por favor Seleccione un Proveedor");
                }
            }
      }
    }


  toggle_drop(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

  handleChangecheckbox(row)
  {
         
    let bandera=0;
    this.setState({
      seleccion_id : parseInt( row.original.value),
      seleccion_label : row.original.label,
    });  
  }

  componentDidMount() {
       // this.props.get();
      
          if (typeof this.props.auth.permisos === "undefined") {
            
          } else {
           console.log('permisos--->',this.props.auth.permisos[2])
           let permisos=this.props.auth.permisos[2];
           this.setState({
              altas:parseInt(permisos.altas)===1?true:false,
              bajas:parseInt(permisos.bajas)===1?true:false,
              cambios:parseInt(permisos.cambios)===1?true:false,
              reportes:parseInt(permisos.reportes)===1?true:false,
              });
           
          }
    }

    render() {
      const { data, pages, loading } = this.state;
       const { altas,bajas,cambios,reportes } = this.state;
        return(
            <div className="view">
            <Menu props={this.props}/>

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Proveedores</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row">
                        { reportes&&
                          <div className="col text-left">
                            <Dropdown nav className='btn-sm info' color="" isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle_drop(1,1);}} >
                              <DropdownToggle nav caret>
                               <IconForms/>Consultas
                              </DropdownToggle>
                              <DropdownMenu className='letras_menu'>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,4,'Cuentas por Pagar (Desglosado)')}>Cuentas por Pagar (Desglosado)</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,0,'Cuentas por Pagar')}>Cuentas por Pagar</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,1,'Cargos / Abonos')}>Cargos / Abonos</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,2, 'Facturas / Abonos')}>Facturas / Abonos</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,3, 'Productos comprados')}>Productos Comprados</DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        }
                          { altas&&
                          <div className="col text-right">
                            <Button color="success" className="mb-2" onClick={this.toggle}>
                                <IconPersonAdd />&nbsp;Agregar
                            </Button>
                          </div>
                        }
                        </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>{
                                              if(cambios){
                                              this.toggle(evt, rowInfo.original.value, 'Editar Proveedor');
                                              }else{
                                                 swal('', 'No tienes permisos para editar');
                                              }
                                            }
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: 'Seleccion',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <input type="checkbox"
                                                name="" 
                                                checked={(this.state.seleccion_id === parseInt( row.original.value)) ? true : false}
                                                onChange={() => this.handleChangecheckbox(row)}/>                                                 
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Proveedor', accessor: 'label',minWidth:300, style: { 'textAlign': 'left'}},
                                {Header: 'Contacto', accessor: 'contacto',minWidth:240, style: { 'textAlign': 'left'} },
                                {Header: 'Telefono', accessor: 'telefono' ,maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Saldo', accessor: 'saldo' ,maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                {cambios&&
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Proveedor')}>
                                                    <IconEdit />
                                                </Button>}{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.proveedores.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 get_cliente={this.get_cliente}
                />
                }
                {
                   this.state.kardexModal&& 
                   <KardexProveedor 
                 open={this.state.kardexModal} 
                 toggle={this.toggleKardex} 
                 title={this.state.title} 
                 proveedor={this.state.seleccion_id}
                 nombreProveedor={this.state.seleccion_label}
                 consulta={this.state.opcionConsulta}
                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        proveedores : state.proveedores,
        auth:state.auth,
    }
};

export default connect(mapStateToProps, actions)(Prveedores)


// WEBPACK FOOTER //
// ./src/views/proveedores/index.js